import { ptColors } from "@/config/colors";

export * from "./styles.js";

export const initialEditorState = {
  isMap: true,
  enabled: true,
  modelId: null,
  mode: "create",
  id: "",
  geom_type: "",
  geometry: "",
  history: [],
  historyIndex: 0,
  activeLayers: [],
  modelLayers: [],
  name: "",
  isDrawing: false,
  loading: false,
  // deleting objects helpers
  deletingCallback: null,
  deletingIds: [],
  dependenciesCount: 0,
  // creating object helpers
  withAttributes: false,
  objectFields: [],
  creatingCallback: null,
  activeObject: null,
  centerGeom: null,
  editingCallback: null,
  // dependencies map helpers
  dependenciesData: {},
  deletedDependenciesIds: []
};

export const scenarioModellingLayersConfig = {
  nodes: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": 3,
      "circle-color": ptColors.baseColor,
      "circle-pitch-alignment": "map"
    }
  },
  links: {
    type: "line",
    layout: {
      "line-join": "round",
      "line-cap": "round"
    },
    paint: {
      "line-color": ptColors.baseColor,
      "line-width": 2
    }
  }
};
